import React, { useState, useRef } from "react";
import Footer2 from "components/Footers/Footer2";
import AdminNavbar from "components/Navbars/AdminNavbar";
import mapscl from "assets/img/mapscl.webp";
// import mail from "assets/img/mail.png";
import mail from "assets/img/new/mail.webp";
import contact from "assets/img/new/contact.webp";
import girlimg from "assets/img/girlimg.png";
import bgg from "assets/img/bgg.png";
import bfly1 from "assets/img/bfly1.webp";
import clouds from "assets/img/clouds.webp";
import emailjs from "@emailjs/browser";
import axios from "axios";
import { API_URL } from "assets/Contsants";
import toast from "react-hot-toast";
import ReCAPTCHA from "react-google-recaptcha";

export default function ContactUs() {
  const form = useRef(null);
  const [formStatus, setFormStatus] = useState("idle");
  const [captchaToken, setCaptchaToken] = useState(null);
  // const sendEmail = (e) => {
  //   e.preventDefault();

  //   emailjs
  //     .sendForm("service_icbt4b6", "template_8d2fljt", form.current, {
  //       publicKey: "k2xgdVDnjkIFOHFOR",
  //     })
  //     .then(
  //       () => {
  //         console.log("SUCCESS!");
  //         setFormStatus("success");
  //         // Check if form.current exists before resetting
  //         if (form.current) {
  //           form.current.reset();
  //         }
  //         setTimeout(() => {
  //           setFormStatus("idle");
  //         }, 3000);
  //       },
  //       (error) => {
  //         console.log("FAILED...", error.text);
  //         setFormStatus("error");
  //         setTimeout(() => {
  //           setFormStatus("idle");
  //         }, 1000);
  //       }
  //     );
  // };

  const sendEmail = async (event) => {
    event.preventDefault();

    const formData = new FormData(event.target);
    const data = {
      fullname: formData.get("name")?.trim(),
      about: formData.get("about"),
      branch: formData.get("branch"),
      email: formData.get("email")?.trim(),
      phone: formData.get("tel")?.trim(),
      message: formData.get("message")?.trim(),
      captcha: captchaToken,
    };

    // Validation checks
    if (!data.fullname) {
      toast.error("Full Name is required");
      return;
    }
    if (!data.phone) {
      toast.error("Phone number is required");
      return;
    }
    if (!/^\d{10}$/.test(data.phone)) {
      toast.error("Enter a valid 10-digit phone number");
      return;
    }
    if (!data.email) {
      toast.error("Email is required");
      return;
    }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(data.email)) {
      toast.error("Enter a valid email address");
      return;
    }
    if (!data.about) {
      toast.error("Please select an option for About");
      return;
    }
    if (!data.branch) {
      toast.error("Please select a Branch");
      return;
    }
    if (!data.message) {
      toast.error("Message is required");
      return;
    }
    if (!captchaToken) {
      toast.error("Please verify you're not a robot");
      return;
    }

    try {
      const response = await axios.post(
        "https://api.juniortoes.com/api/enquires",
        data,
      );

      if (response.status === 200) {
        setFormStatus("success");
        toast.success("Form submitted successfully!");
        event.target.reset();
      }
    } catch (error) {
      console.error("Form submission error:", error);
      setFormStatus("error");
      toast.error("Something went wrong. Please try again.");
    }
  };

  const locations = {
    Malleshwaram:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3887.5314857377316!2d77.56711527405109!3d13.001790514217726!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae162f11b8fc5f%3A0x71930a4be90652c0!2s93%2C%2011th%20Cross%20Rd%2C%20Mec%20Layout%2C%20Vyalikaval%2C%20Kodandarampura%2C%20Malleshwaram%2C%20Bengaluru%2C%20Karnataka%20560003!5e0!3m2!1sen!2sin!4v1738237144789!5m2!1sen!2sin",
    Rajajinagar:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3887.493724005125!2d77.54501437405116!3d13.004200614164763!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae3d9b81e6fb79%3A0x4fcd89797b56cd6b!2s244%2C%201st%20B%20Main%20Rd%2C%20West%20of%20Chord%20Road%202nd%20Stage%2C%202nd%20Stage%2C%20Mahalakshmipuram%2C%20Bengaluru%2C%20Karnataka%20560086!5e0!3m2!1sen!2sin!4v1738237477759!5m2!1sen!2sin",
    RajarajeshwariNagar:
      "https://www.google.com/maps/embed?pb=!1m16!1m12!1m3!1d15554.893394177838!2d77.50372273261166!3d12.92549426231251!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!2m1!1sNo.%20453%2FA%20%2C%20Kempe%20Gowda%20Road%2C%20Ideal%20Homes%20Layout%2C%20Javarandoddi%2C%20Rajarajeshwari%20Nagar%2C%20Bengaluru%2C%20Karnataka%20560098!5e0!3m2!1sen!2sin!4v1738237373508!5m2!1sen!2sin",
    Vijayanagar:
      "https://www.google.com/maps/embed?pb=!1m16!1m12!1m3!1d498389.86857932527!2d76.71558600717688!3d12.603931302243698!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!2m1!1s21%202nd%20Main%20Road%20Mysore%20Income%20Tax%20layout%20Chandra%20layout%20Bangalore%20-%2040!5e0!3m2!1sen!2sin!4v1738237561850!5m2!1sen!2sin",
    RMVDollarsColony:
      "https://www.google.com/maps/embed?pb=!1m16!1m12!1m3!1d497698.77491618396!2d77.3012613173564!3d12.954459537787022!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!2m1!1s321%2C%20RMV%202nd%20Block%2C%202nd%20Stage%2C%202nd%20Cross%2C%20Bangalore-560094Near%2080ft%20road%2C%20coffee%20day!5e0!3m2!1sen!2sin!4v1738238930628!5m2!1sen!2sin",
    Hesaraghatta:
      "https://www.google.com/maps/embed?pb=!1m16!1m12!1m3!1d995648.6269384524!2d76.99288269408302!3d12.891482031342873!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!2m1!1s%20%2081%2F1%2C%20No%2020%2C%20Hebbagodi%20Srinivasa%20Layout%2C%20Hesaraghatta%20Main%20Road%2C%20Bangalore%20%E2%80%93%20560057!5e0!3m2!1sen!2sin!4v1741844529039!5m2!1sen!2sin",
    Acharya:
      "https://www.google.com/maps/embed?pb=!1m16!1m12!1m3!1d15544.866658136889!2d77.47180523265544!3d13.085450646508358!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!2m1!1sAcharya%20pre%20school%2089%2F90%2C%20soldevanahalli%20Heseraghatta%20main%20road%20chickkabanavara%20Bangalore%20-560090.Near%20acharya%20engineering%20college!5e0!3m2!1sen!2sin!4v1738239191462!5m2!1sen!2sin",
    // Yelahanka:
    //   "https://www.google.com/maps/embed?pb=!1m16!1m12!1m3!1d15543.911698652193!2d77.5697114326596!3d13.100584995004926!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!2m1!1s%2327%20MIG%2C%203rd%20phase%2C%20Yelahanka%20New%20Town%2C%20Bengaluru%2C%20Karnataka%20560064!5e0!3m2!1sen!2sin!4v1738239310688!5m2!1sen!2sin",
    ShubhEnclave:
      "https://www.google.com/maps/embed?pb=!1m16!1m12!1m3!1d31111.335939042492!2d77.64215717880082!3d12.913056448169005!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!2m1!1s7-64%2C4th%20Main%2C%20Shubh%20Enclave%2C%20Harlur%20Road%2C%20Ambalipura%2C%20HSR%20Layout%2C%20Bengaluru-560102!5e0!3m2!1sen!2sin!4v1739435775860!5m2!1sen!2sin",
    HSRLayout:
      "https://www.google.com/maps/embed?pb=!1m16!1m12!1m3!1d15556.143756448173!2d77.65293498260621!3d12.905410614285763!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!2m1!1s7-64%2C4th%20Main%2C%20Shubh%20Enclave%2C%20Harlur%20Road%2C%20Ambalipura%2C%20HSR%20Layout%2C%20Bengaluru-560102!5e0!3m2!1sen!2sin!4v1738239426500!5m2!1sen!2sin",
    JayalakshmipuramMysore:
      "https://www.google.com/maps/embed?pb=!1m16!1m12!1m3!1d31185.396064739874!2d76.61256087036261!3d12.304032159244509!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!2m1!1sNo%3A%2065%2C%203rd%20Block%2C%208th%20Main%2C%20Behind%20Zudio%2C%20Jayalakshmipuram%2C%20Mysuru%20%E2%80%94%20570%20012!5e0!3m2!1sen!2sin!4v1741931850442!5m2!1sen!2sin",
    Indiranagar:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3888.0522299146446!2d77.64040117405054!3d12.968509714948125!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae15fa7a845ee5%3A0x834ab0b8db632be!2s1189b%2C%2013th%20Main%20Rd%2C%20beside%20Tarang%20Arts%2C%20HAL%202nd%20Stage%2C%20Indiranagar%2C%20Bengaluru%2C%20Karnataka%20560008!5e0!3m2!1sen!2sin!4v1741931964516!5m2!1sen!2sin",
    Mandya:
      "https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d3894.85044705837!2d76.88601497506892!3d12.526064787749819!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMTLCsDMxJzMzLjgiTiA3NsKwNTMnMTguOSJF!5e0!3m2!1sen!2sin!4v1763714410141!5m2!1sen!2sin",
    JPNagarMetroStation:
      "https://www.google.com/maps/embed?pb=!1m23!1m12!1m3!1d124451.54073021379!2d77.65002179999999!3d12.9006061!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!4m8!3e6!4m0!4m5!1s0x3bae1566129ad9af%3A0xd2d8a9e93be664c3!2sPurva%20Belmont%2C%20Purva%20Belmont%20Apartments%2C%20PURVA%20BELMONT%2C%20Kanakapura%20Main%20Rd%2C%20Kanakanagar%2C%20Yelachenahalli%2C%20Kumaraswamy%20Layout%2C%20Bengaluru%2C%20Karnataka%20560111!3m2!1d12.903580999999999!2d77.5718772!5e0!3m2!1sen!2sin!4v1771934375870!5m2!1sen!2sin",
    Vidyaranyapura:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3886.3323028734294!2d77.55594683727001!3d13.078113841853774!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae23ab01204a11%3A0x93a10159e4e761b4!2sJUNIOR%20TOES%20INTERNATIONAL%20PRE-SCHOOL%20%2CVIDYARANYAPURA!5e0!3m2!1sen!2sin!4v1763716977795!5m2!1sen!2sin",
    Whitefield:
      "https://www.google.com/maps/embed?pb=!1m23!1m12!1m3!1d124447.0227725935!2d77.5734042!3d12.909684299999999!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!4m8!3e6!4m0!4m5!1s0x3bae0df728b4d763%3A0xddebeb10e4e4aa26!2sOlympia%20Enchante%2C%20Olympia%20Enchante%2C%20Hagadur%20Village%2C%20Ozone%20Entrance%20Road%2C%20152%2C%20Hagadur%20Main%20Rd%2C%20Whitefield%2C%20Bengaluru%2C%20Karnataka%20560066!3m2!1d12.961115699999999!2d77.75119029999999!5e0!3m2!1sen!2sin!4v1771934691113!5m2!1sen!2sin",
    Nelamangala:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3886.133188692699!2d77.40317807795297!3d13.090744354323743!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae25e142dd9b17%3A0x8880a157fed19799!2sJunior%20Toes%20Nelamangala!5e0!3m2!1sen!2sin!4v1771935027235!5m2!1sen!2sin",
    Nagarabhavi:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3887.8278819991447!2d77.50869987484151!3d12.982858087333577!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae3dfbdbe84483%3A0xb18de364711101ec!2sJunior%20Toes%20Nagarabhavi!5e0!3m2!1sen!2sin!4v1771935145930!5m2!1sen!2sin",
   RukminiNagarHMTLayout :
      "https://www.google.com/maps/embed?pb=!1m16!1m12!1m3!1d31097.464896897054!2d77.5037211962136!3d13.024008436936182!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!2m1!1s%23599%20%2C3rd%20main%20road%2C%203rd%20block%2C%20HMT%20Layout%2C%20Nagasandra%2C%20Bengaluru%20-%20560073!5e0!3m2!1sen!2sin!4v1771935342010!5m2!1sen!2sin",
  JindalCityNagasandra  :
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3886.659029902852!2d77.48827727484297!3d13.057362387265984!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae23b23da0ed8f%3A0x7a344864b08c78b2!2sJunior%20Toes%20International%20Pre%20School%20-%20Jindal%20City!5e0!3m2!1sen!2sin!4v1771935426241!5m2!1sen!2sin",
  PoornapragnaLayout   :
      "https://www.google.com/maps/embed?pb=!1m16!1m12!1m3!1d7777.992613711745!2d77.53880124066644!3d12.907958649606261!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!2m1!1sNo%2067%2C4th%20Main%20Road%20&#39;Somavali%20Sadana&#39;%20Poorna%20pragna%20nagar%20Uttarahalli%20Bangalore%20-%20560061!5e0!3m2!1sen!2sin!4v1771935546788!5m2!1sen!2sin",
  HebbalDasarahalli    :
      "https://www.google.com/maps/embed?pb=!1m16!1m12!1m3!1d124405.53432107353!2d77.49729475317957!3d12.992757968913457!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!2m1!1s%2364%20%26%2065%2C%207th%20A%20Cross%2C%20Maruthi%20Layout%2C%20Dasarahalli%2C%20Bangalore-%20560024!5e0!3m2!1sen!2sin!4v1771935761960!5m2!1sen!2sin",
  BharathNagar:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3887.8287069615103!2d77.47671737793965!3d12.982805354674012!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae3d16c64c83cd%3A0x72c8fb57f4126964!2sJUNIOR%20TOES%20BHARATHNAGAR!5e0!3m2!1sen!2sin!4v1771935839519!5m2!1sen!2sin",
  Banashankari3rdStage:
      "https://www.google.com/maps/embed?pb=!1m16!1m12!1m3!1d15554.27234976036!2d77.53240064526705!3d12.935458248023307!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!2m1!1s%23687%2C%20KG%20layout%2C%20Banashankari%203rd%20stage%2C%203rd%20phase%2C%20Katriguppe%20water%20tank%2C%20Bangalore%20%E2%80%93%20560085!5e0!3m2!1sen!2sin!4v1771936096459!5m2!1sen!2sin",
   TumkurAdarshanagar:
      "https://www.google.com/maps/embed?pb=!1m16!1m12!1m3!1d62114.316723221644!2d77.04625787540171!3d13.341267724172855!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!2m1!1sAmruthadhara%2C%202nd%20main%20road%20%2C%20Adarsh%20Nagar%20Road%2C%20Tumkur%2C%20572103!5e0!3m2!1sen!2sin!4v1771936210609!5m2!1sen!2sin",
    Sahakarnagar:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3886.6100361252975!2d77.5854208!3d13.0604762!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae19004175417b%3A0x9c19afe10a1f2dae!2zSlVOSU9SIFRPRVMg4LKc4LOC4LKo4LK_4LKv4LKw4LONIOCyn-Czi-CyuOCzjQ!5e0!3m2!1sen!2sin!4v1778662127170!5m2!1sen!2sin",
  };

  const [currentMap, setCurrentMap] = useState(locations.Malleshwaram);

  // Function to handle map update and scroll to the map section
  const updateMapAndScroll = (location) => {
    setCurrentMap(locations[location]);
    // Smoothly scroll to the map section
    document
      .getElementById("map-section")
      .scrollIntoView({ behavior: "smooth" });
  };

  return (
    <>
      <AdminNavbar fixed />

      <section
        className=" xl:pt-28 lg:pt-28 md:pt-24 xl:pb-16 lg:pb-16 md:pb-16 parkinsans pb-12 xl:block lg:block md:block sm:block block"
        style={{
          backgroundColor: "#f0f7fa",
          backgroundImage: `url(${bgg})`,
          backgroundPosition: "center center",
          backgroundRepeat: "repeat",
          backgroundSize: "35% auto",
        }}
      >
        <div className=" container mx-auto gap-6 xl:px-0 px-4">
          <div className=" flex justify-start top-0 absolute right-0 ">
            <img
              className="xl:w-44 lg:w-40 md:w-32 w-20 xl:pt-0 lg:pt-0 md:pt-8 pt-16"
              src={clouds}
              alt=""
            />
          </div>
        </div>
        <div className="flex flex-wrap  container mx-auto xl:px-0 px-4">
          <div className="xl:w-6/12 lg:w-6/12 md:w-6/12 ">
            <h2 class="xl:text-xl lg:text-xl md:text-xl text-xl font-bold text-black xl:mt-12 lg:mt-0 md:mt-6 mt-24 ">
              Get In<span className="text-peach"> Touch With Us</span>
            </h2>

            <div className="border-blue xl:w-2/12 xl:mt-4 lg:w-3/12 w-24 lg:mt-4 md:mt-4 mt-4"></div>

            <h4 className="text-black xl:text-4xl font-semibold  xl:pt-4 lg:pt-4 md:pt-4 pt-4 lg:text-3xl md:text-2xl">
              Little Learners Today, Future Leaders Tomorrow
            </h4>
            <div>
              <p className="xl:text-lg text-black lg:text-lg text-base xl:pt-4 pt-4">
                Thank you for considering us for your child’s early learning
                journey. Please fill out the enquiry form below, and our team
                will get back to you shortly with all the details you need.
              </p>
            </div>

            <h1 className="xl:text-4xl lg:text-2xl md:text-3xl text-2xl font-bold text-blue xl:pt-4 lg:pt-4 md:mt-4 mt-4">
              Admissions Open for Session staring from May 2025
            </h1>

            <div className="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-1 lg:grid-cols-1 xl:grid-cols-2 xl:gap-6 gap-4">
              <div className="flex gap-4 items-center xl:mt-10 lg:mt-8 md:mt-8 mt-6">
                <div className="">
                  <img src={mail} alt="" className="w-14" />
                </div>
                <div className="border-l border-neutral-500">
                  <div className="pl-4">
                    <h5 className="text-blue xl:text-xl lg:text-xl md:text-lg  font-semibold">
                      Mail
                    </h5>
                    <p className="text-base">info@juniortoes.com</p>
                    <p className="text-base">hr@juniortoes.com</p>
                  </div>
                </div>
              </div>

              <div className="flex gap-4 items-center xl:mt-10 lg:mt-4 md:mt-4 xl:ml-0 ">
                <div className="">
                  <img src={contact} alt="" className="w-14" />
                </div>
                <div className="border-l border-neutral-500">
                  <div className="pl-4">
                    <h5 className="text-blue xl:text-xl lg:text-xl md:text-lg font-semibold">
                      Contact
                    </h5>
                    <p className="text-base">+91-9035039983</p>
                    <p className=" text-base">+91-9035039984</p>
                  </div>
                </div>
              </div>
            </div>

            <div>
              <div className="xl:block lg:block md:block sm:hidden hidden ">
                <img className="xl:w-44 w-32 xl:-ml-12" src={bfly1} alt="" />
              </div>
            </div>
          </div>

          <div className="xl:w-6/12 lg:w-6/12 md:w-6/12 xl:mt-0 lg:mt-8 mt-12 md:mt-8">
            <div className="flex">
              <div className="xl:w-4/12 lg:w-4/12 xl:block lg:hidden md:hidden hidden sm:hidden">
                <img className="xl:w-12/12 lg:w-12/12" src={girlimg} alt="" />
              </div>

              <div className=" bg-white border-blue rounded-xl shadow-xl  xl:p-8 lg:p-4 p-4 xl:-ml-4 z-10 ">
                {formStatus === "success" && (
                  <div className="text-center text-green-500 sofia-pro">
                    Thank you for submitting the form!
                  </div>
                )}

                {/* Show Error Message */}
                {formStatus === "error" && (
                  <div className="text-center text-red-500 sofia-pro">
                    There was an error submitting the form. Please try again.
                  </div>
                )}
                <h1 className="xl:text-3xl lg:text-3xl md:text-3xl text-2xl text-black font-bold  text-center xl:mt-6">
                  Enquire Now
                </h1>
                {formStatus === "idle" && (
                  <form
                    className="xl:mt-8 mt-8"
                    ref={form}
                    onSubmit={sendEmail}
                  >
                    <input
                      className="xl:w-12/12 w-12/12 rounded-lg borderform"
                      type="text"
                      name="name"
                      placeholder="Full Name"
                      required
                    />

                    <input
                      className="xl:w-12/12 w-12/12 lg:mt-6 mt-4 xl:mt-6 rounded-lg borderform"
                      type="number"
                      name="tel"
                      placeholder="Phone"
                      required
                    />

                    <input
                      className="xl:w-12/12 xl:mt-6 w-12/12 lg:mt-6 mt-4  rounded-lg borderform"
                      type="text"
                      name="email"
                      placeholder="Email"
                      required
                    />

                    <div className="xl:w-12/12 xl:mt-6 w-12/12 lg:mt-6 mt-4 ">
                      <select
                        className="w-full rounded-lg borderform "
                        name="about"
                        required
                      >
                        <option value="" disabled selected>
                          About
                        </option>

                        <option value="Admission ">Admission </option>
                        <option value="Franchise">Franchise </option>
                        <option value="Job Opportunity ">
                          Job Opportunity{" "}
                        </option>
                        <option value="Investment ">Investment </option>
                        <option value="Others ">Others</option>
                      </select>
                    </div>

                    <div className="xl:w-12/12 xl:mt-6 w-12/12 lg:mt-6 mt-4 ">
                      <select
                        className="w-full rounded-lg borderform "
                        name="branch"
                        required
                      >
                        <option value="" disabled selected>
                          Select Branch
                        </option>
                        <option value="Malleshwaram">Malleshwaram</option>
                        <option value="RR Nagar">RR Nagar</option>
                        <option value="Hesaraghatta Road">
                          Hesaraghatta Road
                        </option>
                        <option value="RMV - Dollar Colony">
                          RMV - Dollar Colony
                        </option>
                        <option value="Rajajinagar"> Rajajinagar </option>
                        {/* <option value="Yelahanka">Yelahanka</option> */}
                        <option value="Acharya College Campus">
                          Acharya College Campus
                        </option>
                        <option value="Vijayanagar">Vijayanagar</option>
                        <option value="HSR Layout">HSR Layout</option>
                        <option value="Shubh Enclave - Haralur, Sarjapur">
                          Shubh Enclave - Haralur, Sarjapur
                        </option>
                        <option value="Indiranagar">Indiranagar</option>
                        <option value="Jayalakshmipuram - Mysore">Jayalakshmipuram - Mysore</option>
                        <option value="JP Nagar Metro Station">JP Nagar Metro Station</option>
                        <option value="Vidyaranyapura">Vidyaranyapura</option>
                        <option value="Mandya">Mandya</option>
                        <option value="Whitefield">Whitefield</option>
                        <option value="Nelamangala">Nelamangala</option>
                        <option value="Nagarbhavi">Nagarbhavi</option>
                        <option value="Rukmini Nagar HMT Layout">Rukmini Nagar – HMT Layout</option>
                        <option value="Jindal City Nagasandra">Jindal City Nagasandra</option>
                        <option value="Poornapragna Layout">Poornapragna Layout</option>
                        <option value="Hebbal Dasarahalli">Hebbal Dasarahalli</option>
                        <option value="Bharath Nagar">Bharath Nagar</option>
                        <option value="Banashankari 3rd Stage">Banashankari 3rd Stage</option>
                        <option value="Tumkur Adarshanagar">Tumkur Adarshanagar</option>
                        <option value="Sahakarnagar">Sahakarnagar</option>
                      </select>
                    </div>

                    <textarea
                      className="xl:w-12/12 xl:mt-6 w-12/12 lg:mt-6 mt-4  rounded-lg borderform"
                      placeholder="Message ..."
                      rows="5"
                      name="message"
                    ></textarea>

                    <ReCAPTCHA
                      sitekey="6Lff5xMsAAAAAI23wsM17cv64hBjF2Q7ZSlCYBee"
                      onChange={(token) => setCaptchaToken(token)}
                      className="w-12/12"
                    />

                    <div className="flex justify-center items-center gap-4 xl:mt-6 mt-6">
                      <input className="mt-1" type="checkbox" id="" />
                      <label
                        className="xl:text-sm lg:text-sm md:text-xs text-sm"
                        for=""
                      >
                        I will be happy to get a call from you about my child’s
                        admission to Junior Toes
                      </label>
                    </div>

                    <div className="flex justify-center xl:mt-6 mt-6">
                      <button
                        className="text-white rounded xl:px-8 xl:py-2 px-8 py-2"
                        style={{ background: "#2d86a4" }}
                        type="submit"
                      >
                        Submit
                      </button>
                    </div>
                  </form>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* tab and mobile view */}
      <section
        className=" md:pt-24 pt-4 pb-12 md:pb-20 parkinsans bgh xl:hidden lg:hidden md:hidden sm:hidden hidden"
        style={{
          backgroundColor: "#f0f7fa",
          backgroundImage: `url(${bgg})`,
          backgroundPosition: "center center",
          backgroundRepeat: "repeat",
          backgroundSize: "55% auto",
        }}
      >
        <div className="px-4">
          <h2 class=" text-xl font-bold text-black md:mt-6 mt-24 ">
            Get In<span className="text-peach"> Touch With Us</span>
          </h2>

          <div className="border-blue w-24  md:mt-4 mt-4"></div>

          <h4 className="text-black font-semibold   pt-4  text-2xl">
            Little Learners Today, Future Leaders Tomorrow
          </h4>
          <div>
            <p className="text-black  text-base  pt-4">
              Thank you for considering us for your child’s early learning
              journey. Please fill out the enquiry form below, and our team will
              get back to you shortly with all the details you need.
            </p>
          </div>

          <h1 className=" md:text-3xl text-2xl font-bold text-blue md:mt-4 mt-4">
            Admissions Open for Session staring from May 2025
          </h1>

          <div className="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-2 md:gap-0">
            <div className="flex gap-4  md:mt-6  mt-4">
              <div className="">
                <img src={mail} alt="" className="w-14" />
              </div>
              <div className="border-l border-neutral-500">
                <div className="pl-4">
                  <h5 className="text-blue md:text-xl text-lg  font-semibold">
                    Mail
                  </h5>
                  <p className="text-base">info@juniortoes.com</p>
                  <p className="text-base">hr@juniortoes.com</p>
                </div>
              </div>
            </div>

            <div className="flex gap-4  md:mt-6  mt-4 md:ml-0 ">
              <div className="">
                <img src={contact} alt="" className="w-14" />
              </div>
              <div className="border-l border-neutral-500">
                <div className="pl-4">
                  <h5 className="text-blue  md:text-xl text-lg font-semibold">
                    Contact
                  </h5>
                  <p className="text-base">+91-9035039983</p>
                  <p className=" text-base">+91-9035039984</p>
                </div>
              </div>
            </div>
          </div>

          <div className="flex md:mt-10  mt-8">
            <div className="md:block sm:hidden hidden">
              <div className="md:w-8/12 ">
                <img className="md:w-12/12 " src={girlimg} alt="" />
              </div>
            </div>
            <div className=" bg-white border-blue rounded-xl shadow-xl md:p-12 p-6 z-10 md:-ml-40">
              {formStatus === "success" && (
                <div className="text-center text-green-500 sofia-pro">
                  Thank you for submitting the form!
                </div>
              )}

              {/* Show Error Message */}
              {formStatus === "error" && (
                <div className="text-center text-red-500 sofia-pro">
                  There was an error submitting the form. Please try again.
                </div>
              )}
              {formStatus === "idle" && (
                <>
                  <h1 className="xl:text-3xl lg:text-3xl md:text-3xl text-2xl text-black font-bold  text-center xl:mt-6">
                    Enquire Now
                  </h1>
                  <form className=" mt-8" ref={form} onSubmit={sendEmail}>
                    <input
                      className=" w-12/12 rounded-lg borderform"
                      type="text"
                      id="text"
                      name="name"
                      placeholder="Full Name"
                      required
                    />

                    <input
                      className="w-12/12  md:mt-6 mt-4  rounded-lg borderform"
                      type="number"
                      id="number"
                      name="tel"
                      placeholder="Phone"
                      required
                    />

                    <input
                      className=" w-12/12 md:mt-6 mt-4  rounded-lg borderform"
                      type="text"
                      id="text"
                      name="email"
                      placeholder="Email"
                      required
                    />

                    <div className=" w-12/12 md:mt-6 mt-4">
                      <select
                        className="w-full rounded borderform "
                        id="academic"
                        name="about"
                        required
                      >
                        <option value="" disabled selected>
                          About
                        </option>

                        <option value="Admission ">Admission </option>
                        <option value="Franchise">Franchise </option>
                        <option value="Job Opportunity ">
                          Job Opportunity{" "}
                        </option>
                        <option value="Investment ">Investment </option>
                        <option value="Others ">Others</option>
                      </select>
                    </div>

                    <textarea
                      className=" w-12/12 md:mt-6 mt-4 rounded-lg borderform"
                      placeholder="Message ..."
                      name="message"
                      rows="5"
                    ></textarea>

                    <div className="flex justify-center items-center gap-4 md:mt-6 mt-6">
                      <input className="mt-1" type="checkbox" id="" />
                      <label
                        className="xl:text-sm lg:text-sm md:text-xs text-sm"
                        for=""
                      >
                        I will be happy to get a call from you about my child’s
                        admission to Junior Toes
                      </label>
                    </div>

                    <div className="flex justify-center mt-6">
                      <button
                        className="text-white rounded  px-8 py-2"
                        style={{ background: "#2d86a4" }}
                        type="submit"
                      >
                        Submit
                      </button>
                    </div>
                  </form>
                </>
              )}
            </div>
          </div>
        </div>
        <div className="xl:hidden lg:hidden md:block sm:block block">
          <div className="flex items-end">
            <img className="w-36 " src={bfly1} alt="" />
          </div>
        </div>
      </section>

      {/* <section className="bg-gray  parkinsans xl:pt-12 xl:pb-16 lg:pt-12 lg:pb-16 md:pt-16 md:pb-16 xl:block lg:block md:block sm:block block pt-12 pb-12">
        <div className="container mx-auto ">
          <h1 className="xl:text-4xl lg:text-4xl md:text-3xl text-2xl text-black font-bold text-center">
            Our Location
          </h1>
          <p className="xl:text-lg lg:text-lg pt-2 xl:pt-2 justify-center mx-auto text-center text-black xl:w-6/12 lg:w-6/12 md:w-6/12 ">
            Welcome to Junior Toes, a place where your child's learning and
            growth are nurtured in a safe and vibrant environment.
          </p>
          <div className="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-8 lg:grid-cols-8 xl:grid-cols-8 xl:mt-12 lg:mt-12 mt-8 xl:px-0 lg:px-4 md:mt-12 md:px-4 px-4">
            <div className=" xl:col-span-3 lg:col-span-3 md:col-span-3 ">
              <h2 className="text-black xl:text-4xl lg:text-4xl md:text-3xl text-xl font-semibold">
                Find Us Here
              </h2>
              <div className="xl:mt-8 lg:mt-6 md:mt-6 mt-6">
                <div className="flex gap-4 items-center">
                  <div className="">
                    <img src={location} alt="" className="w-18" />
                  </div>
                  <div className="border-l border-neutral-500 xl:ml-0 lg:ml-5 md:ml-6 ml-3">
                    <div className="pl-4">
                      <h5 className="text-blue xl:text-xl lg:text-xl md:text-lg font-semibold">
                        Location
                      </h5>
                      <p className="text-base xl:w-9/12 lg:w-10/12 md:w-9/12">
                        108-48, 7th Sector, HSR Layout, Bangalore, Karnataka.
                      </p>
                    </div>
                  </div>
                </div>

                <div className="flex gap-4 items-center xl:mt-10 lg:mt-8 md:mt-8 mt-6">
                  <div className="">
                    <img src={mail} alt="" className="w-14" />
                  </div>
                  <div className="border-l border-neutral-500">
                    <div className="pl-4">
                      <h5 className="text-blue xl:text-xl lg:text-xl md:text-lg md:mt-8 font-semibold">
                        Mail
                      </h5>
                      <p className="text-base">info@juniortoes.com</p>
                      <p className="text-base">hr@juniortoes.com</p>
                    </div>
                  </div>
                </div>

                <div className="flex gap-4 items-center xl:mt-10 lg:mt-8 md:mt-8 mt-6">
                  <div className="">
                    <img src={contact} alt="" className="w-14" />
                  </div>
                  <div className="border-l border-neutral-500">
                    <div className="pl-4">
                      <h5 className="text-blue xl:text-xl lg:text-xl md:text-lg font-semibold">
                        Contact
                      </h5>
                      <p className="text-base">+91-9535039983</p>
                      <p className=" text-base">+91 9035039984</p>
                    </div>
                  </div>
                </div>



              </div>
            </div>

           
          </div>
        </div>
      </section> */}

      <section
        className="xl:pt-16  xl:pb-24 parkinsans lg:pt-16 lg:pb-20 md:pt-16 md:pb-16 xl:block lg:block md:block sm:block block pt-12 pb-12"
        // style={{ background: "#f0eded" }}
      >
        <div className="container mx-auto">
          <p className="xl:text-lg lg:text-lg md:text-lg text-center text-peach font-semibold uppercase bubblegum">
            We are excited{" "}
          </p>
          <div className="xl:block lg:block md:hidden sm:hidden hidden">
            <h1 className="xl:text-4xl lg:text-3xl md:text-3xl font-semibold text-center text-black ">
              To announce the launch of 10+ locations across bangalore<br></br>{" "}
              for the academic year June 2025.
            </h1>
          </div>
          {/* tab and mobile */}
          <div className="xl:hidden lg:hidden md:block sm:block block">
            <h1 className=" md:text-3xl text-2xl font-semibold text-center text-black ">
              To announce the launch of 10+ locations across bangalore for the
              academic year June 2025.
            </h1>
          </div>
          <p className="xl:text-base lg:text-base text-base pt-2 xl:pt-2 text-black text-center">
            Admissions will open in January 2025!
          </p>

          <div className="flex justify-center">
            <div
              id="map-section"
              className=" xl:mt-6 lg:mt-8 md:mt-6 mt-6 xl:w-8/12 lg:w-8/12 md:w-10/12 "
            >
              <div className="container overflow-hidden">
                <iframe
                  className="xl:w-full rounded-xl xl:h-400 lg:h-380 lg:w-12/12 md:w-12/12 w-12/12 md:h-380"
                  src={currentMap}
                  allowFullScreen
                  loading="lazy"
                  title="Google Map"
                ></iframe>
              </div>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 xl:grid-cols-4 xl:mt-12 lg:mt-8 md:mt-8 gap-6 xl:px-0 lg:px-4 h-full w-full xl:px-0 px-4 mt-8">
            <div onClick={() => updateMapAndScroll("Malleshwaram")}>
              <div
                className="bg-white rounded-xl xl:p-8 lg:p-6 p-6 h-full w-full flex flex-col justify-between "
                style={{
                  borderLeft: "4px solid #f3eb93",
                  backgroundColor: "#f0f7fa",
                  backgroundImage: `url(${bgg})`,
                  backgroundPosition: "center center",
                  backgroundRepeat: "repeat",
                  backgroundSize: "100% auto",
                }}
              >
                <p className="xl:text-base text-black font-semibold text-center">
                  <span className="text-blue">
                    {" "}
                    Junior Toes - Malleshwaram{" "}
                  </span>
                  <br></br> 93, 11th Cross, 8th Main Malleswaram, Bangalore
                  560003, Near Abbee Hearing Solutions
                </p>

                <div className="">
                  <div
                    className="rounded-xl xl:py-2 py-2 bottom-0 xl:mt-3 lg:mt-3 md:mt-3 mt-4"
                    style={{
                      background: "#FEFACF",
                    }}
                  >
                    <div className="flex justify-center  gap-2 ">
                      <a href="tel:+919035038826">
                        <div className="cursor-pointer flex items-center gap-2">
                          <i
                            class="las la-phone text-2xl"
                            style={{ color: "#0189a5" }}
                          ></i>
                          <h1 className="text-black xl:text-base text-sm font-semibold">
                            +91 9035038826
                          </h1>
                        </div>
                      </a>
                    </div>
                  </div>
                  <div
                    className="rounded-xl shadow-xl   xl:py-2 py-2 bottom-0 xl:mt-2 lg:mt-2 md:mt-2 mt-4"
                    style={{
                      background: "#FEFACF",
                    }}
                  >
                    <div className="flex justify-center  gap-2 ">
                      <div className="cursor-pointer flex items-center gap-2">
                         <i
                            class="las la-map-marker text-2xl"
                            style={{ color: "#0189a5" }}
                          ></i>
                        <h1 className="text-black xl:text-base text-sm font-semibold">
                          Malleshwaram
                        </h1>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div onClick={() => updateMapAndScroll("Rajajinagar")}>
              <div
                className="bg-white rounded-xl xl:p-8 lg:p-6 p-6 h-full w-full flex flex-col justify-between"
                style={{
                  borderLeft: "4px solid #cbc1c1",
                  backgroundColor: "#f0f7fa",
                  backgroundImage: `url(${bgg})`,
                  backgroundPosition: "center center",
                  backgroundRepeat: "repeat",
                  backgroundSize: "100% auto",
                }}
              >
                <p className="xl:text-base text-black font-semibold text-center">
                  <span className="text-blue px-2">
                    {" "}
                    Junior Toes - Rajajinagar{" "}
                  </span>
                  <br></br>
                  244, 1st B Main Rd, West of Chord Road 2nd Stage,
                  Mahalakshmipuram, Bengaluru, Karnataka 560086{" "}
                </p>

                <div className="">
                  <div
                    className="rounded-xl   xl:py-2 py-2 bottom-0 xl:mt-3 lg:mt-3 md:mt-3 mt-4"
                    style={{
                      background: "#DADADA",
                    }}
                  >
                    <div className="flex justify-center  gap-2 ">
                      <a href="tel:+919035039292">
                        <div className="cursor-pointer flex items-center gap-2">
                          <i
                            class="las la-phone text-2xl"
                            style={{ color: "#0189a5" }}
                          ></i>
                          <h1 className="text-black xl:text-base text-sm font-semibold">
                            +91 9035039292
                          </h1>
                        </div>
                      </a>
                    </div>
                  </div>

                  <div
                    className="rounded-xl shadow-xl mt-3  xl:py-2 py-2"
                    style={{
                      background: "#DADADA",
                    }}
                  >
                    <div className="flex justify-center items-center gap-2">
                      <div className="cursor-pointer flex items-center gap-2">
                        <i
                            class="las la-map-marker text-2xl"
                            style={{ color: "#0189a5" }}
                          ></i>
                        <h1 className="text-black xl:text-base text-sm font-semibold">
                          Rajajinagar
                        </h1>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div onClick={() => updateMapAndScroll("RajarajeshwariNagar")}>
              <div
                className="bg-white rounded-xl xl:p-8 lg:p-6 p-6 h-full w-full flex flex-col justify-between"
                style={{
                  borderLeft: "4px solid #f1d19e",
                  backgroundColor: "#f0f7fa",
                  backgroundImage: `url(${bgg})`,
                  backgroundPosition: "center center",
                  backgroundRepeat: "repeat",
                  backgroundSize: "100% auto",
                }}
              >
                <p className="xl:text-base text-black font-semibold text-center">
                  <span className="text-blue "> Junior Toes - RR Nagar </span>
                  <br></br>
                  No. 453/A , Kempe Gowda Road, Ideal Homes Layout,
                  Javarandoddi, Rajarajeshwari Nagar, Bengaluru, Karnataka
                  560098
                </p>
                <div className="">
                  <div
                    className="rounded-xl   xl:py-2 py-2 bottom-0 xl:mt-3 lg:mt-3 md:mt-3 mt-4"
                    style={{
                      background: "#F1E1C8",
                    }}
                  >
                    <div className="flex justify-center  gap-2 ">
                      <a href="tel:+919035038825">
                        <div className="cursor-pointer flex items-center gap-2">
                          <i
                            class="las la-phone text-2xl"
                            style={{ color: "#0189a5" }}
                          ></i>
                          <h1 className="text-black xl:text-base text-sm font-semibold">
                            +91 9035038825
                          </h1>
                        </div>
                      </a>
                    </div>
                  </div>
                  <div
                    className="rounded-xl shadow-xl mt-3  xl:py-2 py-2"
                    style={{
                      background: "#F1E1C8",
                    }}
                  >
                    <div className="flex justify-center items-center gap-2">
                      <div className="cursor-pointer flex items-center gap-2">
                        <i
                            class="las la-map-marker text-2xl"
                            style={{ color: "#0189a5" }}
                          ></i>
                        <h1 className="text-black xl:text-base text-sm font-semibold">
                          Rajarajeshwari Nagar
                        </h1>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div onClick={() => updateMapAndScroll("Vijayanagar")}>
              <div
                className="bg-white rounded-xl xl:p-8 lg:p-6 p-6 h-full w-full flex flex-col justify-between"
                style={{
                  borderLeft: "4px solid #f1beab",
                  backgroundColor: "#f0f7fa",
                  backgroundImage: `url(${bgg})`,
                  backgroundPosition: "center center",
                  backgroundRepeat: "repeat",
                  backgroundSize: "100% auto",
                }}
              >
                <p className="xl:text-base text-black font-semibold text-center">
                  <span className="text-blue text-base">
                    {" "}
                    Junior Toes - Vijayanagar{" "}
                  </span>
                  <br></br>
                  21 2nd Main Road Mysore Income Tax layout Chandra layout
                  Bangalore - 40
                </p>
                <div className="">
                  <div
                    className="rounded-xl   xl:py-2 py-2 bottom-0 xl:mt-3 lg:mt-3 md:mt-3 mt-4"
                    style={{
                      background: "#F4CDBE",
                    }}
                  >
                    <div className="flex justify-center  gap-2 ">
                      <a href="tel:+919035038827">
                        <div className="cursor-pointer flex items-center gap-2">
                          <i
                            class="las la-phone text-2xl"
                            style={{ color: "#0189a5" }}
                          ></i>
                          <h1 className="text-black xl:text-base text-sm font-semibold">
                            +91 9035038827
                          </h1>
                        </div>
                      </a>
                    </div>
                  </div>
                  <div
                    className="rounded-xl shadow-xl mt-3  xl:py-2 py-2"
                    style={{
                      background: "#F4CDBE",
                    }}
                  >
                    <div className="flex justify-center items-center gap-2">
                      <div className="cursor-pointer flex items-center gap-2">
                        <i
                            class="las la-map-marker text-2xl"
                            style={{ color: "#0189a5" }}
                          ></i>
                        <h1 className="text-black xl:text-base text-sm font-semibold">
                          Vijayanagar
                        </h1>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div onClick={() => updateMapAndScroll("RMVDollarsColony")}>
              <div
                className="bg-white rounded-xl xl:p-8 lg:p-6 p-6 h-full w-full flex flex-col justify-between"
                style={{
                  borderLeft: "4px solid #f1e0cf",
                  backgroundColor: "#f0f7fa",
                  backgroundImage: `url(${bgg})`,
                  backgroundPosition: "center center",
                  backgroundRepeat: "repeat",
                  backgroundSize: "100% auto",
                }}
              >
                <p className="xl:text-base text-black font-semibold text-center">
                  <span className="text-blue px-2 text-base">
                    {" "}
                    Junior Toes - RMV - Dollars Colony{" "}
                  </span>
                  <br></br>
                  321, RMV 2nd Block, 2nd Stage, 2nd Cross, Bangalore-560094.
                  Near 80ft road, coffee day
                </p>
                <div className="">
                  <div
                    className="rounded-xl xl:py-2 py-2 bottom-0 xl:mt-3 lg:mt-3 md:mt-3 mt-4"
                    style={{
                      background: "#F2F1F0",
                    }}
                  >
                    <div className="flex justify-center  gap-2 ">
                      <a href="tel:+919035039293">
                        <div className="cursor-pointer flex items-center gap-2">
                          <i
                            class="las la-phone text-2xl"
                            style={{ color: "#0189a5" }}
                          ></i>
                          <h1 className="text-black xl:text-base text-sm font-semibold">
                            +91 9035039293
                          </h1>
                        </div>
                      </a>
                    </div>
                  </div>
                  <div
                    className="rounded-xl shadow-xl mt-3 xl:py-2 py-2"
                    style={{
                      background: "#F2F1F0",
                    }}
                  >
                    <div className="flex justify-center items-center gap-2">
                      <div className="cursor-pointer flex items-center gap-2">
                        <i
                            class="las la-map-marker text-2xl"
                            style={{ color: "#0189a5" }}
                          ></i>
                        <h1 className="text-black xl:text-base text-sm font-semibold">
                          RMV - Dollars Colony
                        </h1>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div onClick={() => updateMapAndScroll("Hesaraghatta")}>
              <div
                className="bg-white rounded-xl xl:p-8 lg:p-6 p-6 h-full w-full flex flex-col justify-between"
                style={{
                  borderLeft: "4px solid #ffe9e4",
                  backgroundColor: "#f0f7fa",
                  backgroundImage: `url(${bgg})`,
                  backgroundPosition: "center center",
                  backgroundRepeat: "repeat",
                  backgroundSize: "100% auto",
                }}
              >
                <p className="xl:text-base text-black font-semibold text-center">
                  <span className="text-blue px-2 text-base">
                    {" "}
                    Junior Toes - Hesaraghatta Road{" "}
                  </span>
                  <br></br>
                  SAS DREAM EDUCATION PVT LTD 81/1, No 20, Hebbagodi Srinivasa
                  Layout, Hesaraghatta Main Road, Bangalore – 560057
                </p>
                <div className="">
                  <div
                    className="rounded-xl xl:py-2 py-2 bottom-0 xl:mt-3 lg:mt-3 md:mt-3 mt-4"
                    style={{
                      background: "#fff2ef",
                    }}
                  >
                    <div className="flex justify-center  gap-2 ">
                      <a href="tel:+919035096889">
                        <div className="cursor-pointer flex items-center gap-2">
                          <i
                            class="las la-phone text-2xl"
                            style={{ color: "#0189a5" }}
                          ></i>
                          <h1 className="text-black xl:text-base text-sm font-semibold">
                            +91 9035096889
                          </h1>
                        </div>
                      </a>
                    </div>
                  </div>
                  <div
                    className="rounded-xl shadow-xl mt-3 xl:py-2 py-2"
                    style={{
                      background: "#fff2ef",
                    }}
                  >
                    <div className="flex justify-center items-center gap-2">
                      <div className="cursor-pointer flex items-center gap-2">
                        <i
                            class="las la-map-marker text-2xl"
                            style={{ color: "#0189a5" }}
                          ></i>
                        <h1 className="text-black xl:text-base text-sm font-semibold">
                          Hesaraghatta Road
                        </h1>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div onClick={() => updateMapAndScroll("Acharya")}>
              <div
                className="bg-white rounded-xl xl:p-8 lg:p-6 p-6 h-full w-full flex flex-col justify-between"
                style={{
                  borderLeft: "4px solid #bef3ff",
                  backgroundColor: "#f0f7fa",
                  backgroundImage: `url(${bgg})`,
                  backgroundPosition: "center center",
                  backgroundRepeat: "repeat",
                  backgroundSize: "100% auto",
                }}
              >
                <p className="xl:text-base text-black font-semibold text-center">
                  <span className="text-blue px-2 text-base">
                    {" "}
                    Junior Toes - Acharya{" "}
                  </span>
                  <br></br>
                  Acharya pre school 89/90, soldevanahalli Heseraghatta main
                  road chickkabanavara Bangalore -560090. Near acharya
                  engineering college
                </p>
                <div className="">
                  <div
                    className="rounded-xl xl:py-2 py-2 bottom-0 xl:mt-3 lg:mt-3 md:mt-3 mt-4"
                    style={{
                      background: "#e2f9fe",
                    }}
                  >
                    <div className="flex justify-center  gap-2 ">
                      <a href="tel:+919035096893">
                        <div className="cursor-pointer flex items-center gap-2">
                          <i
                            class="las la-phone text-2xl"
                            style={{ color: "#0189a5" }}
                          ></i>
                          <h1 className="text-black xl:text-base text-sm font-semibold">
                            +91 9035096893
                          </h1>
                        </div>
                      </a>
                    </div>
                  </div>
                  <div
                    className="rounded-xl shadow-xl mt-3 xl:py-2 py-2"
                    style={{
                      background: "#e2f9fe",
                    }}
                  >
                    <div className="flex justify-center items-center gap-2">
                      <div className="cursor-pointer flex items-center gap-2">
                        <i
                            class="las la-map-marker text-2xl"
                            style={{ color: "#0189a5" }}
                          ></i>
                        <h1 className="text-black xl:text-base text-sm font-semibold">
                          Acharya
                        </h1>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div
              className="center-button xl:px-0 lg:px-0 md:px-0 px-4"
              onClick={() => updateMapAndScroll("ShubhEnclave")}
            >
              <div className="">
                <div
                  className="bg-white rounded-xl xl:p-8 lg:p-6 p-6 h-full w-full flex flex-col justify-between"
                  style={{
                    borderLeft: "4px solid #bef3ff",
                    backgroundColor: "#f0f7fa",
                    backgroundImage: `url(${bgg})`,
                    backgroundPosition: "center center",
                    backgroundRepeat: "repeat",
                    backgroundSize: "100% auto",
                  }}
                >
                  <p className="xl:text-base text-black font-semibold text-center">
                    <span className="text-blue px-2 text-base">
                      {" "}
                      Junior Toes - Haralur, Sarjapur{" "}
                    </span>
                    <br></br>
                    7-64,4th Main, Shubh Enclave, Haralur Road, Ambalipura, HSR
                    Layout, Bengaluru-560102
                  </p>
                  <div className="">
                    <div
                      className="rounded-xl xl:py-2 py-2 bottom-0 xl:mt-3 lg:mt-3 md:mt-3 mt-4"
                      style={{
                        background: "#F2F1F0",
                      }}
                    >
                      <div className="flex justify-center  gap-2 ">
                        <a href="tel:+919035038824">
                          <div className="cursor-pointer flex items-center gap-2">
                            <i
                              class="las la-phone text-2xl"
                              style={{ color: "#0189a5" }}
                            ></i>
                            <h1 className="text-black xl:text-base text-sm font-semibold">
                              +91 9035038824
                            </h1>
                          </div>
                        </a>
                      </div>
                    </div>
                    <div
                      className="rounded-xl shadow-xl mt-3 xl:py-2 py-2"
                      style={{
                        background: "#F2F1F0",
                      }}
                    >
                      <div className="flex justify-center items-center gap-2">
                        <div className="cursor-pointer flex items-center gap-2">
                          <i
                            class="las la-map-marker text-2xl"
                            style={{ color: "#0189a5" }}
                          ></i>
                          <h1 className="text-black xl:text-base text-sm font-semibold">
                            Shubh Enclave
                          </h1>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div
              className="center-button xl:px-0 lg:px-0 md:px-0 px-4"
              onClick={() => updateMapAndScroll("HSRLayout")}
            >
              <div className="">
                <div
                  className="bg-white rounded-xl xl:p-8 lg:p-6 p-6 h-full w-full flex flex-col xl:mt-6 mt-6 justify-between"
                  style={{
                    borderLeft: "4px solid #f3eb93",
                    backgroundColor: "#f0f7fa",
                    backgroundImage: `url(${bgg})`,
                    backgroundPosition: "center center",
                    backgroundRepeat: "repeat",
                    backgroundSize: "100% auto",
                  }}
                >
                  <p className="xl:text-base text-black font-semibold text-center">
                    <span className="text-blue px-2 text-base">
                      {" "}
                      Junior Toes - HSR Layout{" "}
                    </span>
                    <br></br>
                    House No: 61, 16th Cross, 15th Main, 4 Sector, HSR Layout,
                    Near Cakewala, Opp BDA Complex, Bangalore -560102
                  </p>
                  <div className="">
                    <div
                      className="rounded-xl xl:py-2 py-2 bottom-0 xl:mt-3 lg:mt-3 md:mt-3 mt-4"
                      style={{
                        background: "#FEFACF",
                      }}
                    >
                      <div className="flex justify-center  gap-2 ">
                        <a href="tel:+919035038830">
                          <div className="cursor-pointer flex items-center gap-2">
                            <i
                              class="las la-phone text-2xl"
                              style={{ color: "#0189a5" }}
                            ></i>
                            <h1 className="text-black xl:text-base text-sm font-semibold">
                              +91 9035038830
                            </h1>
                          </div>
                        </a>
                      </div>
                    </div>
                    <div
                      className="rounded-xl shadow-xl mt-3 xl:py-2 py-2"
                      style={{
                        background: "#FEFACF",
                      }}
                    >
                      <div className="flex justify-center items-center gap-2">
                        <div className="cursor-pointer flex items-center gap-2">
                          <i
                            class="las la-map-marker text-2xl"
                            style={{ color: "#0189a5" }}
                          ></i>
                          <h1 className="text-black xl:text-base text-sm font-semibold">
                            HSR Layout
                          </h1>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div onClick={() => updateMapAndScroll("Vidyaranyapura")}>
              <div
                className="bg-white rounded-xl xl:p-8 lg:p-6 p-6 h-full flex flex-col xl:mt-6 mt-6 justify-between"
                style={{
                  borderLeft: "4px solid #f1beab",
                  backgroundColor: "#f0f7fa",
                  backgroundImage: `url(${bgg})`,
                  backgroundPosition: "center center",
                  backgroundRepeat: "repeat",
                  backgroundSize: "100% auto",
                }}
              >
                <p className="xl:text-base text-black font-semibold text-center">
                  <span className="text-blue text-base">
                    {" "}
                    Junior Toes - Vidyaranyapura{" "}
                  </span>
                  <br></br>
                  240, 8th Main Rd, near Saibaba temple, NTI Layout,
                  Vidyaranyapura, Bengaluru, Karnataka 560097.
                </p>
                <div className="">
                  <div
                    className="rounded-xl   xl:py-2 py-2 bottom-0 xl:mt-3 lg:mt-3 md:mt-3 mt-4"
                    style={{
                      background: "#DADADA",
                    }}
                  >
                    <div className="flex justify-center  gap-2 ">
                      <a href="tel:+919035096891">
                        <div className="cursor-pointer flex items-center gap-2">
                          <i
                            class="las la-phone text-2xl"
                            style={{ color: "#0189a5" }}
                          ></i>
                          <h1 className="text-black xl:text-base text-sm font-semibold">
                            +91 9035096891
                          </h1>
                        </div>
                      </a>
                    </div>
                  </div>
                  <div
                    className="rounded-xl shadow-xl mt-3  xl:py-2 py-2"
                    style={{
                      background: "#DADADA",
                    }}
                  >
                    <div className="flex justify-center items-center gap-2">
                      <div className="cursor-pointer flex items-center gap-2">
                        <i
                            class="las la-map-marker text-2xl"
                            style={{ color: "#0189a5" }}
                          ></i>
                        <h1 className="text-black xl:text-base text-sm font-semibold">
                          Vidyaranyapura
                        </h1>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div
              className="center-button xl:px-0 lg:px-0 md:px-0 px-4"
              onClick={() => updateMapAndScroll("Indiranagar")}
            >
              <div className="">
                <div
                  className="bg-white rounded-xl xl:p-8 lg:p-6 p-6 h-full w-full flex flex-col xl:mt-6 mt-6 justify-between"
                  style={{
                    borderLeft: "4px solid #d7cdc4",
                    backgroundColor: "#f0f7fa",
                    backgroundImage: `url(${bgg})`,
                    backgroundPosition: "center center",
                    backgroundRepeat: "repeat",
                    backgroundSize: "100% auto",
                  }}
                >
                  <p className="xl:text-base text-black font-semibold text-center">
                    <span className="text-blue px-2 text-base">
                      {" "}
                      Junior Toes - Indiranagar{" "}
                    </span>
                    <br></br>
                    1189, 13th Main Rd, HAL 2nd Stage, Indiranagar, Bengaluru,
                    Karnataka 560008
                  </p>
                  <div className="">
                    <div
                      className="rounded-xl xl:py-2 py-2 bottom-0 xl:mt-3 lg:mt-3 md:mt-3 mt-4"
                      style={{
                        background: "#F1E1C8",
                      }}
                    >
                      <div className="flex justify-center  gap-2 ">
                        <a href="tel:+919035039028">
                          <div className="cursor-pointer flex items-center gap-2">
                            <i
                              class="las la-phone text-2xl"
                              style={{ color: "#0189a5" }}
                            ></i>
                            <h1 className="text-black xl:text-base text-sm font-semibold">
                              +91 9035039028
                            </h1>
                          </div>
                        </a>
                      </div>
                    </div>
                    <div
                      className="rounded-xl shadow-xl mt-3 xl:py-2 py-2"
                      style={{
                        background: "#F1E1C8",
                      }}
                    >
                      <div className="flex justify-center items-center gap-2">
                        <div className="cursor-pointer flex items-center gap-2">
                          <i
                            class="las la-map-marker text-2xl"
                            style={{ color: "#0189a5" }}
                          ></i>
                          <h1 className="text-black xl:text-base text-sm font-semibold">
                            Indiranagar
                          </h1>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div
              className="center-button xl:px-0 lg:px-0 md:px-0 px-4"
              onClick={() => updateMapAndScroll("JayalakshmipuramMysore")}
            >
              <div className="">
                <div
                  className="bg-white rounded-xl xl:p-8 lg:p-6 p-6 h-full w-full flex flex-col xl:mt-6 mt-6 justify-between"
                  style={{
                    borderLeft: "4px solid #f1beab",
                    backgroundColor: "#f0f7fa",
                    backgroundImage: `url(${bgg})`,
                    backgroundPosition: "center center",
                    backgroundRepeat: "repeat",
                    backgroundSize: "100% auto",
                  }}
                >
                  <p className="xl:text-base text-black font-semibold text-center">
                    <span className="text-blue px-2 text-base">
                      {" "}
                      Junior Toes - Jayalakshmipuram - Mysore{" "}
                    </span>
                    <br></br>
                    No: 65, 3rd Block, 8th Main, Behind Zudio, Jayalakshmipuram,
                    Mysuru — 570 012
                  </p>
                  <div className="">
                    <div
                      className="rounded-xl xl:py-2 py-2 bottom-0 xl:mt-3 lg:mt-3 md:mt-3 mt-4"
                      style={{
                        background: "#F4CDBE",
                      }}
                    >
                      <div className="flex justify-center  gap-2 ">
                        <a href="tel:+919035038829">
                          <div className="cursor-pointer flex items-center gap-2">
                            <i
                              class="las la-phone text-2xl"
                              style={{ color: "#0189a5" }}
                            ></i>
                            <h1 className="text-black xl:text-base text-sm font-semibold">
                              +91 9035038829
                            </h1>
                          </div>
                        </a>
                      </div>
                    </div>
                    <div
                      className="rounded-xl shadow-xl mt-3 xl:py-2 py-2"
                      style={{
                        background: "#F4CDBE",
                      }}
                    >
                      <div className="flex justify-center items-center gap-2">
                        <div className="cursor-pointer flex items-center gap-2">
                          <i
                            class="las la-map-marker text-2xl"
                            style={{ color: "#0189a5" }}
                          ></i>
                          <h1 className="text-black xl:text-base text-sm font-semibold">
                            Mysore
                          </h1>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div
              className="center-button xl:px-0 lg:px-0 md:px-0 px-4"
              onClick={() => updateMapAndScroll("Mandya")}
            >
              <div className="">
                <div
                  className="bg-white rounded-xl xl:p-8 lg:p-6 p-6 h-full w-full flex flex-col xl:mt-6 mt-6 justify-between"
                  style={{
                    borderLeft: "4px solid #f1beab",
                    backgroundColor: "#f0f7fa",
                    backgroundImage: `url(${bgg})`,
                    backgroundPosition: "center center",
                    backgroundRepeat: "repeat",
                    backgroundSize: "100% auto",
                  }}
                >
                  <p className="xl:text-base text-black font-semibold text-center">
                    <span className="text-blue px-2 text-base">
                      {" "}
                      Junior Toes - Mandya{" "}
                    </span>
                    <br></br>
                    Subhash Nagar 1 st cross, Mandya 571401. Landmark ; behind
                    PES degree college .
                  </p>
                  <div className="">
                    <div
                      className="rounded-xl xl:py-2 py-2 bottom-0 xl:mt-3 lg:mt-3 md:mt-3 mt-4"
                      style={{
                        background: "#F2F1F0",
                      }}
                    >
                      <div className="flex justify-center  gap-2 ">
                        <a href="tel:+919035096896">
                          <div className="cursor-pointer flex items-center gap-2">
                            <i
                              class="las la-phone text-2xl"
                              style={{ color: "#0189a5" }}
                            ></i>
                            <h1 className="text-black xl:text-base text-sm font-semibold">
                              +91 9035096896
                            </h1>
                          </div>
                        </a>
                      </div>
                    </div>
                    <div
                      className="rounded-xl shadow-xl mt-3 xl:py-2 py-2"
                      style={{
                        background: "#F2F1F0",
                      }}
                    >
                      <div className="flex justify-center items-center gap-2">
                        <div className="cursor-pointer flex items-center gap-2">
                          <i
                            class="las la-map-marker text-2xl"
                            style={{ color: "#0189a5" }}
                          ></i>
                          <h1 className="text-black xl:text-base text-sm font-semibold">
                            Mandya
                          </h1>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div onClick={() => updateMapAndScroll("JPNagarMetroStation")}>
              <div
                className="bg-white rounded-xl xl:p-8 lg:p-6 p-6 h-full flex flex-col xl:mt-6 mt-6 justify-between"
                style={{
                  borderLeft: "4px solid #f1beab",
                  backgroundColor: "#f0f7fa",
                  backgroundImage: `url(${bgg})`,
                  backgroundPosition: "center center",
                  backgroundRepeat: "repeat",
                  backgroundSize: "100% auto",
                }}
              >
                <p className="xl:text-base text-black font-semibold text-center">
                  <span className="text-blue text-base">
                    {" "}
                    Junior Toes - JP Nagar Metro Station{" "}
                  </span>
                  <br></br>
                  23, 23C/A, Kanakapura Main Rd, near PURVA BELMONT, Ramakrishna
                  Nagar, Indi, Bengaluru, Karnataka 560078.
                </p>
                <div className="">
                  <div
                    className="rounded-xl   xl:py-2 py-2 bottom-0 xl:mt-3 lg:mt-3 md:mt-3 mt-4"
                    style={{
                      background: "#fff2ef",
                    }}
                  >
                    <div className="flex justify-center  gap-2 ">
                      <a href="tel:+919035096898">
                        <div className="cursor-pointer flex items-center gap-2">
                          <i
                            class="las la-phone text-2xl"
                            style={{ color: "#0189a5" }}
                          ></i>
                          <h1 className="text-black xl:text-base text-sm font-semibold">
                            +91 9035096898
                          </h1>
                        </div>
                      </a>
                    </div>
                  </div>
                  <div
                    className="rounded-xl shadow-xl mt-3  xl:py-2 py-2"
                    style={{
                      background: "#fff2ef",
                    }}
                  >
                    <div className="flex justify-center items-center gap-2">
                      <div className="cursor-pointer flex items-center gap-2">
                        <i
                            class="las la-map-marker text-2xl"
                            style={{ color: "#0189a5" }}
                          ></i>
                        <h1 className="text-black xl:text-base text-sm font-semibold">
                          JP Nagar Metro Station
                        </h1>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div onClick={() => updateMapAndScroll("Whitefield")}>
              <div
                className="bg-white rounded-xl xl:p-8 lg:p-6 p-6 h-full flex flex-col xl:mt-6 mt-6 justify-between"
                style={{
                  borderLeft: "4px solid #f1beab",
                  backgroundColor: "#f0f7fa",
                  backgroundImage: `url(${bgg})`,
                  backgroundPosition: "center center",
                  backgroundRepeat: "repeat",
                  backgroundSize: "100% auto",
                }}
              >
                <p className="xl:text-base text-black font-semibold text-center">
                  <span className="text-blue text-base">
                    {" "}
                    Junior Toes - Whitefield{" "}
                  </span>
                  <br></br>
                  Villa 1, Olympia Enchante, Hagadur Village, Ozone Entrance
                  Road, Whitefield, Bengaluru – 560066.
                </p>
                <div className="">
                  <div
                    className="rounded-xl   xl:py-2 py-2 bottom-0 xl:mt-3 lg:mt-3 md:mt-3 mt-4"
                    style={{
                      background: "#e2f9fe",
                    }}
                  >
                    <div className="flex justify-center  gap-2 ">
                      <a href="tel:+919035203269">
                        <div className="cursor-pointer flex items-center gap-2">
                          <i
                            class="las la-phone text-2xl"
                            style={{ color: "#0189a5" }}
                          ></i>
                          <h1 className="text-black xl:text-base text-sm font-semibold">
                            +91 9035203269
                          </h1>
                        </div>
                      </a>
                    </div>
                  </div>
                  <div
                    className="rounded-xl shadow-xl mt-3  xl:py-2 py-2"
                    style={{
                      background: "#e2f9fe",
                    }}
                  >
                    <div className="flex justify-center items-center gap-2">
                      <div className="cursor-pointer flex items-center gap-2">
                        <i
                            class="las la-map-marker text-2xl"
                            style={{ color: "#0189a5" }}
                          ></i>
                        <h1 className="text-black xl:text-base text-sm font-semibold">
                          Whitefield
                        </h1>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div onClick={() => updateMapAndScroll("Nelamangala")}>
              <div
                className="bg-white rounded-xl xl:p-8 lg:p-6 p-6 h-full flex flex-col xl:mt-6 mt-6 justify-between"
                style={{
                  borderLeft: "4px solid #f1beab",
                  backgroundColor: "#f0f7fa",
                  backgroundImage: `url(${bgg})`,
                  backgroundPosition: "center center",
                  backgroundRepeat: "repeat",
                  backgroundSize: "100% auto",
                }}
              >
                <p className="xl:text-base text-black font-semibold text-center">
                  <span className="text-blue text-base">
                    {" "}
                    Junior Toes - Nelamangala{" "}
                  </span>
                  <br></br>
                  59, Vinayaka Nagar, Sadashiva Nagara, Nelamangala Town,
                  Nagarur, Bengaluru – 562123.
                </p>
                <div className="">
                  <div
                    className="rounded-xl   xl:py-2 py-2 bottom-0 xl:mt-3 lg:mt-3 md:mt-3 mt-4"
                    style={{
                      background: "#F2F1F0",
                    }}
                  >
                    <div className="flex justify-center  gap-2 ">
                      <a href="tel:+919035096897">
                        <div className="cursor-pointer flex items-center gap-2">
                          <i
                            class="las la-phone text-2xl"
                            style={{ color: "#0189a5" }}
                          ></i>
                          <h1 className="text-black xl:text-base text-sm font-semibold">
                            +91 9035096897
                          </h1>
                        </div>
                      </a>
                    </div>
                  </div>
                  <div
                    className="rounded-xl shadow-xl mt-3  xl:py-2 py-2"
                    style={{
                      background: "#F2F1F0",
                    }}
                  >
                    <div className="flex justify-center items-center gap-2">
                      <div className="cursor-pointer flex items-center gap-2">
                        <i
                            class="las la-map-marker text-2xl"
                            style={{ color: "#0189a5" }}
                          ></i>
                        <h1 className="text-black xl:text-base text-sm font-semibold">
                          Nelamangala
                        </h1>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div onClick={() => updateMapAndScroll("Nagarbhavi")}>
              <div
                className="bg-white rounded-xl xl:p-8 lg:p-6 p-6 h-full flex flex-col xl:mt-6 mt-6 justify-between"
                style={{
                  borderLeft: "4px solid #f1beab",
                  backgroundColor: "#f0f7fa",
                  backgroundImage: `url(${bgg})`,
                  backgroundPosition: "center center",
                  backgroundRepeat: "repeat",
                  backgroundSize: "100% auto",
                }}
              >
                <p className="xl:text-base text-black font-semibold text-center">
                  <span className="text-blue text-base">
                    {" "}
                    Junior Toes - Nagarbhavi{" "}
                  </span>
                  <br></br>
                  1st Block, 14, Outer ring road, Nagarbhavi second stage,
                  Bengaluru – 560072.
                </p>
                <div className="">
                  <div
                    className="rounded-xl   xl:py-2 py-2 bottom-0 xl:mt-3 lg:mt-3 md:mt-3 mt-4"
                    style={{
                      background: "#FEFACF",
                    }}
                  >
                    <div className="flex justify-center  gap-2 ">
                      <a href="tel:+919035203469">
                        <div className="cursor-pointer flex items-center gap-2">
                          <i
                            class="las la-phone text-2xl"
                            style={{ color: "#0189a5" }}
                          ></i>
                          <h1 className="text-black xl:text-base text-sm font-semibold">
                            +91 9035203469
                          </h1>
                        </div>
                      </a>
                    </div>
                  </div>
                  <div
                    className="rounded-xl shadow-xl mt-3  xl:py-2 py-2"
                    style={{
                      background: "#FEFACF",
                    }}
                  >
                    <div className="flex justify-center items-center gap-2">
                      <div className="cursor-pointer flex items-center gap-2">
                        <i
                            class="las la-map-marker text-2xl"
                            style={{ color: "#0189a5" }}
                          ></i>
                        <h1 className="text-black xl:text-base text-sm font-semibold">
                          Nagarbhavi
                        </h1>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div
              onClick={() => updateMapAndScroll("RukminiNagarHMTLayout")}
            >
              <div
                className="bg-white rounded-xl xl:p-8 lg:p-6 p-6 h-full flex flex-col xl:mt-6 mt-6 justify-between"
                style={{
                  borderLeft: "4px solid #f1beab",
                  backgroundColor: "#f0f7fa",
                  backgroundImage: `url(${bgg})`,
                  backgroundPosition: "center center",
                  backgroundRepeat: "repeat",
                  backgroundSize: "100% auto",
                }}
              >
                <p className="xl:text-base text-black font-semibold text-center">
                  <span className="text-blue text-base">
                    {" "}
                    Junior Toes - Rukmini Nagar – HMT Layout{" "}
                  </span>
                  <br></br>
                  #599 ,3rd main road, 3rd block, HMT Layout, Nagasandra,
                  Bengaluru - 560073.
                </p>
                <div className="">
                  <div
                    className="rounded-xl   xl:py-2 py-2 bottom-0 xl:mt-3 lg:mt-3 md:mt-3 mt-4"
                    style={{
                      background: "#DADADA",
                    }}
                  >
                    <div className="flex justify-center  gap-2 ">
                      <a href="tel:+919071702999">
                        <div className="cursor-pointer flex items-center gap-2">
                          <i
                            class="las la-phone text-2xl"
                            style={{ color: "#0189a5" }}
                          ></i>
                          <h1 className="text-black xl:text-base text-sm font-semibold">
                            +91 9071702999
                          </h1>
                        </div>
                      </a>
                    </div>
                  </div>
                  <div
                    className="rounded-xl shadow-xl mt-3  xl:py-2 py-2"
                    style={{
                      background: "#DADADA",
                    }}
                  >
                    <div className="flex justify-center items-center gap-2">
                      <div className="cursor-pointer flex items-center gap-2">
                        <i
                            class="las la-map-marker text-2xl"
                            style={{ color: "#0189a5" }}
                          ></i>
                        <h1 className="text-black xl:text-base text-sm font-semibold">
                          Rukmini Nagar
                        </h1>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div onClick={() => updateMapAndScroll("JindalCityNagasandra")}>
              <div
                className="bg-white rounded-xl xl:p-8 lg:p-6 p-6 h-full flex flex-col xl:mt-6 mt-6 justify-between"
                style={{
                  borderLeft: "4px solid #f1beab",
                  backgroundColor: "#f0f7fa",
                  backgroundImage: `url(${bgg})`,
                  backgroundPosition: "center center",
                  backgroundRepeat: "repeat",
                  backgroundSize: "100% auto",
                }}
              >
                <p className="xl:text-base text-black font-semibold text-center">
                  <span className="text-blue text-base">
                    {" "}
                    Junior Toes - Jindal City Nagasandra{" "}
                  </span>
                  <br></br>
                  20, 3rd Cross, Mayanna Layout, Shrikantapura, Anchepalya,
                  Bengaluru - 560073.
                </p>
                <div className="">
                  <div
                    className="rounded-xl   xl:py-2 py-2 bottom-0 xl:mt-3 lg:mt-3 md:mt-3 mt-4"
                    style={{
                      background: "#F1E1C8",
                    }}
                  >
                    <div className="flex justify-center  gap-2 ">
                      <a href="tel:+919108109991">
                        <div className="cursor-pointer flex items-center gap-2">
                          <i
                            class="las la-phone text-2xl"
                            style={{ color: "#0189a5" }}
                          ></i>
                          <h1 className="text-black xl:text-base text-sm font-semibold">
                            +91 9108109991
                          </h1>
                        </div>
                      </a>
                    </div>
                  </div>
                  <div
                    className="rounded-xl shadow-xl mt-3  xl:py-2 py-2"
                    style={{
                      background: "#F1E1C8",
                    }}
                  >
                    <div className="flex justify-center items-center gap-2">
                      <div className="cursor-pointer flex items-center gap-2">
                        <i
                            class="las la-map-marker text-2xl"
                            style={{ color: "#0189a5" }}
                          ></i>
                        <h1 className="text-black xl:text-base text-sm font-semibold">
                          Jindal City Nagasandra
                        </h1>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div onClick={() => updateMapAndScroll("PoornapragnaLayout")}>
              <div
                className="bg-white rounded-xl xl:p-8 lg:p-6 p-6 h-full flex flex-col xl:mt-6 mt-6 justify-between"
                style={{
                  borderLeft: "4px solid #f1beab",
                  backgroundColor: "#f0f7fa",
                  backgroundImage: `url(${bgg})`,
                  backgroundPosition: "center center",
                  backgroundRepeat: "repeat",
                  backgroundSize: "100% auto",
                }}
              >
                <p className="xl:text-base text-black font-semibold text-center">
                  <span className="text-blue text-base">
                    {" "}
                    Junior Toes - Poornapragna Layout{" "}
                  </span>
                  <br></br>
                  No 67,4th Main Road 'Somavali Sadana' Poorna pragna nagar
                  Uttarahalli Bangalore - 560061.
                </p>
                <div className="">
                  <div
                    className="rounded-xl   xl:py-2 py-2 bottom-0 xl:mt-3 lg:mt-3 md:mt-3 mt-4"
                    style={{
                      background: "#F4CDBE",
                    }}
                  >
                    <div className="flex justify-center  gap-2 ">
                      <a href="tel:+919071705999">
                        <div className="cursor-pointer flex items-center gap-2">
                          <i
                            class="las la-phone text-2xl"
                            style={{ color: "#0189a5" }}
                          ></i>
                          <h1 className="text-black xl:text-base text-sm font-semibold">
                            +91 9071705999
                          </h1>
                        </div>
                      </a>
                    </div>
                  </div>
                  <div
                    className="rounded-xl shadow-xl mt-3  xl:py-2 py-2"
                    style={{
                      background: "#F4CDBE",
                    }}
                  >
                    <div className="flex justify-center items-center gap-2">
                      <div className="cursor-pointer flex items-center gap-2">
                        <i
                            class="las la-map-marker text-2xl"
                            style={{ color: "#0189a5" }}
                          ></i>
                        <h1 className="text-black xl:text-base text-sm font-semibold">
                          Poornapragna Layout
                        </h1>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div onClick={() => updateMapAndScroll("HebbalDasarahalli")}>
              <div
                className="bg-white rounded-xl xl:p-8 lg:p-6 p-6 h-full flex flex-col xl:mt-6 mt-6 justify-between"
                style={{
                  borderLeft: "4px solid #f1beab",
                  backgroundColor: "#f0f7fa",
                  backgroundImage: `url(${bgg})`,
                  backgroundPosition: "center center",
                  backgroundRepeat: "repeat",
                  backgroundSize: "100% auto",
                }}
              >
                <p className="xl:text-base text-black font-semibold text-center">
                  <span className="text-blue text-base">
                    {" "}
                    Junior Toes - Hebbal Dasarahalli{" "}
                  </span>
                  <br></br>
                  #64 & 65, 7th A Cross, Maruthi Layout, Dasarahalli, Bangalore-
                  560024.
                </p>
                <div className="">
                  <div
                    className="rounded-xl   xl:py-2 py-2 bottom-0 xl:mt-3 lg:mt-3 md:mt-3 mt-4"
                    style={{
                      background: "#F2F1F0",
                    }}
                  >
                    <div className="flex justify-center  gap-2 ">
                      <a href="tel:+919035203270">
                        <div className="cursor-pointer flex items-center gap-2">
                          <i
                            class="las la-phone text-2xl"
                            style={{ color: "#0189a5" }}
                          ></i>
                          <h1 className="text-black xl:text-base text-sm font-semibold">
                            +91 9035203270
                          </h1>
                        </div>
                      </a>
                    </div>
                  </div>
                  <div
                    className="rounded-xl shadow-xl mt-3  xl:py-2 py-2"
                    style={{
                      background: "#F2F1F0",
                    }}
                  >
                    <div className="flex justify-center items-center gap-2">
                      <div className="cursor-pointer flex items-center gap-2">
                        <i
                            class="las la-map-marker text-2xl"
                            style={{ color: "#0189a5" }}
                          ></i>
                        <h1 className="text-black xl:text-base text-sm font-semibold">
                          Hebbal Dasarahalli
                        </h1>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div onClick={() => updateMapAndScroll("BharathNagar")}>
              <div
                className="bg-white rounded-xl xl:p-8 lg:p-6 p-6 h-full flex flex-col xl:mt-6 mt-6 justify-between"
                style={{
                  borderLeft: "4px solid #f1beab",
                  backgroundColor: "#f0f7fa",
                  backgroundImage: `url(${bgg})`,
                  backgroundPosition: "center center",
                  backgroundRepeat: "repeat",
                  backgroundSize: "100% auto",
                }}
              >
                <p className="xl:text-base text-black font-semibold text-center">
                  <span className="text-blue text-base">
                    {" "}
                    Junior Toes - Bharath Nagar{" "}
                  </span>
                  <br></br>
                  #62/6, Beside Kabbalamma Temple, Byadarahalli, Bharathnagar
                  1st Stage, Vishvaneedam Post, Bengaluru - 560091.
                </p>
                <div className="">
                  <div
                    className="rounded-xl   xl:py-2 py-2 bottom-0 xl:mt-3 lg:mt-3 md:mt-3 mt-4"
                    style={{
                      background: "#fff2ef",
                    }}
                  >
                    <div className="flex justify-center  gap-2 ">
                      <a href="tel:+919035096894">
                        <div className="cursor-pointer flex items-center gap-2">
                          <i
                            class="las la-phone text-2xl"
                            style={{ color: "#0189a5" }}
                          ></i>
                          <h1 className="text-black xl:text-base text-sm font-semibold">
                            +91 9035096894
                          </h1>
                        </div>
                      </a>
                    </div>
                  </div>
                  <div
                    className="rounded-xl shadow-xl mt-3  xl:py-2 py-2"
                    style={{
                      background: "#fff2ef",
                    }}
                  >
                    <div className="flex justify-center items-center gap-2">
                      <div className="cursor-pointer flex items-center gap-2">
                        <i
                            class="las la-map-marker text-2xl"
                            style={{ color: "#0189a5" }}
                          ></i>
                        <h1 className="text-black xl:text-base text-sm font-semibold">
                          Bharath Nagar
                        </h1>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div onClick={() => updateMapAndScroll("Banashankari3rdStage ")}>
              <div
                className="bg-white rounded-xl xl:p-8 lg:p-6 p-6 h-full flex flex-col xl:mt-6 mt-6 justify-between"
                style={{
                  borderLeft: "4px solid #f1beab",
                  backgroundColor: "#f0f7fa",
                  backgroundImage: `url(${bgg})`,
                  backgroundPosition: "center center",
                  backgroundRepeat: "repeat",
                  backgroundSize: "100% auto",
                }}
              >
                <p className="xl:text-base text-black font-semibold text-center">
                  <span className="text-blue text-base">
                    {" "}
                    Junior Toes - Banashankari 3rd Stage{" "}
                  </span>
                  <br></br>
                  #687, KG layout, Banashankari 3rd stage, 3rd phase, Katriguppe
                  water tank, Bangalore – 560085.
                </p>
                <div className="">
                  <div
                    className="rounded-xl   xl:py-2 py-2 bottom-0 xl:mt-3 lg:mt-3 md:mt-3 mt-4"
                    style={{
                      background: "#e2f9fe",
                    }}
                  >
                    <div className="flex justify-center  gap-2 ">
                      <a href="tel:+919035273621">
                        <div className="cursor-pointer flex items-center gap-2">
                          <i
                            class="las la-phone text-2xl"
                            style={{ color: "#0189a5" }}
                          ></i>
                          <h1 className="text-black xl:text-base text-sm font-semibold">
                            +91 9035273621
                          </h1>
                        </div>
                      </a>
                    </div>
                  </div>
                  <div
                    className="rounded-xl shadow-xl mt-3  xl:py-2 py-2"
                    style={{
                      background: "#e2f9fe",
                    }}
                  >
                    <div className="flex justify-center items-center gap-2">
                      <div className="cursor-pointer flex items-center gap-2">
                        <i
                            class="las la-map-marker text-2xl"
                            style={{ color: "#0189a5" }}
                          ></i>
                        <h1 className="text-black xl:text-base text-sm font-semibold">
                          Banashankari 3rd Stage
                        </h1>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div onClick={() => updateMapAndScroll("TumkurAdarshanagar")}>
              <div
                className="bg-white rounded-xl xl:p-8 lg:p-6 p-6 h-full flex flex-col xl:mt-6 mt-6 justify-between"
                style={{
                  borderLeft: "4px solid #f1beab",
                  backgroundColor: "#f0f7fa",
                  backgroundImage: `url(${bgg})`,
                  backgroundPosition: "center center",
                  backgroundRepeat: "repeat",
                  backgroundSize: "100% auto",
                }}
              >
                <p className="xl:text-base text-black font-semibold text-center">
                  <span className="text-blue text-base">
                    {" "}
                    Junior Toes - Tumkur Adarshanagar{" "}
                  </span>
                  <br></br>
                  Amruthadara, 2nd main road , Adarsh Nagar Road, Tumkur,
                  572103.
                </p>
                <div className="">
                  <div
                    className="rounded-xl   xl:py-2 py-2 bottom-0 xl:mt-3 lg:mt-3 md:mt-3 mt-4"
                    style={{
                      background: "#F2F1F0",
                    }}
                  >
                    <div className="flex justify-center  gap-2 ">
                      <a href="tel:+919035203272">
                        <div className="cursor-pointer flex items-center gap-2">
                          <i
                            class="las la-phone text-2xl"
                            style={{ color: "#0189a5" }}
                          ></i>
                          <h1 className="text-black xl:text-base text-sm font-semibold">
                            +91 9035203272
                          </h1>
                        </div>
                      </a>
                    </div>
                  </div>
                  <div
                    className="rounded-xl shadow-xl mt-3  xl:py-2 py-2"
                    style={{
                      background: "#F2F1F0",
                    }}
                  >
                    <div className="flex justify-center items-center gap-2">
                      <div className="cursor-pointer flex items-center gap-2">
                        <i
                            class="las la-map-marker text-2xl"
                            style={{ color: "#0189a5" }}
                          ></i>
                        <h1 className="text-black xl:text-base text-sm font-semibold">
                          Tumkur Adarshanagar
                        </h1>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div onClick={() => updateMapAndScroll("Sahakarnagar")}>
              <div
                className="bg-white rounded-xl xl:p-8 lg:p-6 p-6 h-full flex flex-col xl:mt-6 mt-6 justify-between"
                style={{
                  borderLeft: "4px solid #f1beab",
                  backgroundColor: "#f0f7fa",
                  backgroundImage: `url(${bgg})`,
                  backgroundPosition: "center center",
                  backgroundRepeat: "repeat",
                  backgroundSize: "100% auto",
                }}
              >
                <p className="xl:text-base text-black font-semibold text-center">
                  <span className="text-blue text-base">
                    {" "}
                    Junior Toes - Sahakarnagar{" "}
                  </span>
                  <br></br>
                  2153, 16th E Cross Rd, CQAL Layout, Sahakar Nagar, Bengaluru, Karnataka - 560092
                </p>
                <div className="">
                  <div
                    className="rounded-xl   xl:py-2 py-2 bottom-0 xl:mt-3 lg:mt-3 md:mt-3 mt-4"
                    style={{
                      background: "#FEFACF",
                    }}
                  >
                    <div className="flex justify-center  gap-2 ">
                      <a href="tel:+919035273624">
                        <div className="cursor-pointer flex items-center gap-2">
                          <i
                            class="las la-phone text-2xl"
                            style={{ color: "#0189a5" }}
                          ></i>
                          <h1 className="text-black xl:text-base text-sm font-semibold">
                            +91 9035273624
                          </h1>
                        </div>
                      </a>
                    </div>
                  </div>
                  <div
                    className="rounded-xl shadow-xl mt-3  xl:py-2 py-2"
                    style={{
                    background: "#FEFACF",
                    }}
                  >
                    <div className="flex justify-center items-center gap-2">
                      <div className="cursor-pointer flex items-center gap-2">
                        <i
                            class="las la-map-marker text-2xl"
                            style={{ color: "#0189a5" }}
                          ></i>
                        <h1 className="text-black xl:text-base text-sm font-semibold">
                         Sahakarnagar
                        </h1>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </section>

      <Footer2 />
    </>
  );
}
